<template> 
  <div class="flex flex-col overflow-hidden bg-white">
    <div class="flex flex-row bg-white justify-between items-center px-10 h-14 my-4">
      <div class="text-dark text-2xl font-semibold h-15 text-center mr-auto">DOCTOR ROSTER</div>
      <div class="flex flex-row justify-between m-2 ml-auto">
        <div class="flex">
          <select @change="onMonthYearChange" v-model="selectedMonth.value" class="flex appearance-none mr-2 w-auto h-8 pl-2 bg-white border border-solid rounded-sm border-grey-lightest text-sm text-grey-darkest focus:border-blue">
            <option v-for="(month,index) in months"  :key="index" v-bind:value="month.value">
              {{ month.text }}
            </option>
          </select>
          <select @change="onMonthYearChange" v-model="selectedYear" class="flex appearance-none w-16 h-8 pl-2 bg-white border border-solid rounded-sm border-grey-lightest text-sm text-grey-darkest focus:border-blue" >
            <option v-for="(year,index) in years" :key="index" v-bind:value="year">
              {{ year }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="flex flex-col flex-no-shrink flex-no-grow">
      <div class="doc_header bg-grey-lightest">
        <div v-if="!['externalAdmin'].includes(this.role)" @click="setActiveSlots('family_doctor')" v-bind:class="[activeSlots === 'family_doctor' ? 'text-blue' : 'hover:text-blue']" class="text-grey text-md font-semibold cursor-pointer hover:text-blue pt-1">Internal Doctors</div>          
        <div @click="setActiveSlots('external_doctor')" v-bind:class="[activeSlots === 'external_doctor' ? 'text-blue' : 'hover:text-blue']" class="text-grey text-md font-semibold cursor-pointer pt-1">External Doctors</div>
      </div>
    </div> 
    <div class="flex flex-row bg-grey-lightest mb-4" style="height: 0.125rem">
      <div v-if="!['externalAdmin'].includes(this.role)" class="w-1/2" v-bind:class="[activeSlots === 'family_doctor' ? 'bg-blue' : '']"></div>
      <div class="w-1/2" v-bind:class="[activeSlots === 'external_doctor' ? 'bg-blue' : '']"></div>
    </div>
    <doctor-slots :rosterType="activeSlots" :selectedMonth="selectedMonth.value" :selectedYear="selectedYear"/>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import moment from 'moment'
import DoctorSlots from './DoctorSlots'
export default {
  components: { DoctorSlots },
  data () {
    let today = moment(new Date())
    return {
      checkedMohanDr: false,
      checkedMaheshDr: false,
      checkedVarunDr: false,
      checkedArmanDr: false,
      showModal: false,
      openReplaceDr: false,
      selectedDoctor: {},
      isLoading: false,
      addDoctors: false,
      addSelectedDoctor: {},
      timeSlots: ['07:00-07:30', '07:30-08:00', '08:00-08:30', '08:30-09:00', '09:00-09:30', '09:30-10:00', '10:00-10:30', '10:30-11:00', '11:00-11:30', '11:30-12:00', '12:00-12:30', '12:30-13:00', '13:00-13:30', '13:30-14:00', '14:00-14:30', '14:30-15:00', '15:00-15:30', '15:30-16:00', '16:00-16:30', '16:30-17:00', '17:00-17:30', '17:30-18:00', '18:00-18:30', '18:30-19:00', '19:00-19:30', '19:30-20:00', '20:00-20:30', '20:30-21:00', '21:00-21:30', '21:30-22:00', '22:00-22:30', '22:30-23:00'],
      doctors: [],
      years: [2022, 2023, 2024],
      months: [{text: 'January', value: '01'}, {text: 'Feburary', value: '02'}, {text: 'March', value: '03'}, {text: 'April', value: '04'}, {text: 'May', value: '05'}, {text: 'June', value: '06'},
      {text: 'July', value: '07'}, {text: 'August', value: '08'}, {text: 'September', value: '09'}, {text: 'October', value: 10}, {text: 'November', value: 11}, {text: 'December', value: 12}],
      selectedMonth: {value: today.format('MM'), text: today.format('MMMM')},
      selectedYear: today.format('YYYY'),
      response: [],
      slotDoctors: [],
      activeSlots: 'family_doctor'
    }
  },
  computed: {
    ...mapGetters({
      role: 'configuration/getRole'
    }),
    dates: function () {
      return Object.keys(this.response)
    }
  },
  methods: {
    onMonthYearChange: function () {
      this.getDoctorsSlots()
    },
    openModal: function (showModal, slot, date) {
      if (this.role !== 'admin') {
        return
      }
      this.showModal = !this.showModal
      this.selectedSlot = slot
      this.selectedDate = date
      this.slotDoctors = this.getDocsForASlot(slot, date)
    },
    closeModal: function () {
      this.slotDoctors = []
      this.selectedDate = ''
      this.selectedSlot = ''
      this.selectedDoctor = {}
      this.showModal = false
      this.addDoctors = false
      this.openReplaceDr = false
      this.getDoctorsSlots()
    },
    dateObject: function (date) {
      if (Object.keys(this.response[date]).length > 0) {
        return Object.keys(this.response[date])
      }
      return []
    },
    selectDoctors: function (i, doc) {
      this.doctors[i].selected = !this.doctors[i].selected
    },
    showAllDoctors: function () {
      this.doctors.map(doctor => { doctor.selected = false })
    },
    setActiveSlots: function (section) {
      this.activeSlots = section
    }
  },
  watch: {
    role: {
      immediate: true,
      handler (newRole) {
        if (newRole === 'externalAdmin') {
          this.activeSlots = 'external_doctor'
        }
      }
    }
  }
}
</script>

<style scoped>
  table{
      display: grid;
      grid-template-columns: 148px repeat(31, 72px);
      grid-template-rows: 48px repeat(32, 72px);
      grid-auto-flow: column;
  }
  thead,tbody,tr {
      display: contents;
  }
  /* CSS + selector is used to apply box-shadow to all the TD that are placed immediately after TD */
  td + td  {
      box-shadow: inset 0px 0px 0px 0.5px #d7dbde;
  }
  th {
    font-weight: normal
  }
  /* Circlur dot for each doctor*/
  .doc-circle{
      width: 20px;
      height: 20px;
      border-radius: 50%;
      color: white;
      /* font-size: 12px; */
      background-color: darkgrey; /* default circular background base color */
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      margin: 4px;
      flex-shrink: 0;
  }
  .doc_header{
  padding: 0;
  display: grid;
  height: 28px;
  margin: 0px 1px 0px 1px;
  text-align: center;
  grid-template-columns: 
    auto auto
}

  /* doctor colors */
</style>



// WEBPACK FOOTER //
// src/components/DoctorRoster/DoctorSchedule.vue